import authenticationFlow from "./authenticationFlow";
import convertersFlow from "./convertersFlow";
import conversionsFlow from "./conversionsFlow";
import modariscomunicationFlow from "./modariscomunicationFlow";

export default function* rootSaga() {
  yield* convertersFlow();
  yield* conversionsFlow();
  yield* modariscomunicationFlow();
  yield* authenticationFlow();
}
